import { useTimeframeTime } from 'features/user';
import React from 'react';
import { Goal } from 'shared/types/goal';

import { InsightsCard } from './insights-card';

export type LoadingInsightsCardProps = {
  goal: Goal;
};

export const LoadingInsightsCard: React.FC<LoadingInsightsCardProps> = ({
  goal,
}) => {
  const { startDate, endDate } = useTimeframeTime({
    weekEndsWithStartOfDay: true,
  });

  return (
    <InsightsCard
      goal={goal}
      entries={[]}
      startDate={startDate}
      endDate={endDate}
      isLoading
    />
  );
};
